import React, { useState } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import {
  getTranslation,
  getUser,
  getHeaderMode,
  getActualPage,
  getActiveElement,
  getMagazine, getPages,
} from '@/store/getters'
import { setHeaderMode } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import Actions from './components/Actions'
import ExportMagazine from './components/ExportMagazine'

import IconComponent from '@/components/commons/IconComponent'
import EmbedMagazine from '@/components/EmbedMagazine'
import MagazineEditorTitle from "./components/MagazineTitleEditable";

const Header = props => {
  const {
    isLogginPage,
    translation,
    headerMode,
    history,
    magazine,
    id_magazine,
  } = props

  const headerClass = isLogginPage
    ? `${styles['wrapper-header']} ${styles['wrapper-header__none']}`
    : `${styles['wrapper-header']}`

  const isEditor = /editor/g.test(headerMode)
  // const isDashBoard = /normal/g.test(headerMode)
  const isPreview = /preview/g.test(headerMode)
  const isExportedPdf = /exported-pdfs/g.test(headerMode)

  const [showEmbed, setShowEmbed] = useState(false)

  return (
    <header>
      {/* Preview Header */}
      {isPreview && <section className={headerClass} id="mainHeader">
        <div className={styles['wrapper-header__content']}>
          <a href={`/magazines/${magazine.id}`}>
            <button
              type="button"
              tooltip={translation('general-edit-magazine')}
              tooltip-position="bottom"
              className={styles['wrapper-header__magazine']}
            >
              <IconComponent icon="magazine" />
            </button>
          </a>
        </div>
      </section>}

      {/* PDFs Exported Header */}
      {isExportedPdf && <section section className={headerClass} id="mainHeader">
        <div className={styles['wrapper-header__content']}>
          <React.Fragment>
            <div className={styles['exported-pdfs']}>
              <button
                type="button"
                className="basic-button icon-button"
                onClick={() => history.go(-1)}
              >
                <IconComponent icon="return" />
              </button>
              <div>
                <span>{translation('magazine-pdfs-exported')}</span>
              </div>
            </div>

          </React.Fragment>
        </div>
      </section>}

      {/* Editor Header */}
      {isEditor && <section className={headerClass} id="mainHeader">
        <div className={styles['wrapper-header__content']}>
          <React.Fragment>
            {/* TODO remove when ready
            <div className='ba-flex'>
              <button
                ba-tooltip-title={translation('general-undo')}
                ba-tooltip-position='bottom'
                class='ba-btn ba-btn-normal ba-sm ba-rounded ba-mg-r-1'>
                <builderall-icon code='5cb0' />
              </button>
              <button
                ba-tooltip-title={translation('general-redo')}
                ba-tooltip-position='bottom'
                class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='de5a' />
              </button>
            </div>*/}
            <MagazineEditorTitle/>

            <div className='ba-flex ba-gp-04'>
              <ExportMagazine />
              <button
                onClick={() => setShowEmbed(true)}
                ba-tooltip-title={translation('action-embed')}
                ba-tooltip-position='bottom'
                ba-tooltip-color='dark'
                className='ba-btn ba-btn-add ba-sm ba-rounded'>
                <IconComponent icon='close-tag' />
              </button>
              <a
                href={`/preview/${id_magazine}`}
                ba-tooltip-title={translation('action-preview')}
                ba-tooltip-position='bottom'
                ba-tooltip-color='dark'
                className='ba-btn ba-btn-add ba-sm ba-rounded'>
                <builderall-icon code='eye'></builderall-icon>
              </a>
            </div>

            <Actions />
          </React.Fragment>
        </div>
        <EmbedMagazine
          show={showEmbed}
          id_magazine={id_magazine}
          handleClose={() => setShowEmbed(false)}
        />
      </section>}
    </header >
  )
}

const mapStateToProps = (state, ownProps) => {
  const translation = getTranslation(state)
  const user = getUser(state)
  const headerMode = getHeaderMode(state)
  const actualPage = getActualPage(state)
  const activeElement = getActiveElement(state)
  const magazine = getMagazine(state)

  const firstPage = getPages(state)[0]

  // se nao encontrar id no redux, pega direto da url
  const id_magazine = firstPage ? firstPage.id_magazine : ownProps.location.pathname.split('/').pop()
  
  return {
    translation,
    user,
    headerMode,
    actualPage,
    activeElement,
    magazine,
    id_magazine
  }
}

export default withRouter(connect(
  mapStateToProps,
  { setHeaderMode }
)(Header))



// WEBPACK FOOTER //
// ./src/components/Heade/index.js